import { InputBase, IconButton,Divider,Box,CircularProgress } from "@mui/material";
import Tree from "rc-tree";
import { useTranslation } from "react-i18next"

import "../../../assets/css/rcTree.css";
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import SearchIcon from '@mui/icons-material/Search';
import { useEffect, useRef, useState } from "react";
import { useDispatch,useSelector } from "react-redux";
import { newTemplateActions } from "../../../redux/slices/newTemplateSlice";
import { api } from "../../../redux/api";

export default function NtwLeftPanel() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { account } = useSelector(state =>state.queryParams)
  const { disableTree } = useSelector(state => state.newTemplate)
  const [repositoryTemplateTree,setRepositoryTemplateTree] = useState([]);
  const [genSelectedKeys, setGenSelectedKeys] = useState(["ntw-0-0"]);
  const [genExpandedKeys, setGenExpandedKeys] = useState(["ntw-0"]);
  const [repSelectedKeys, setRepSelectedKeys] = useState([]);
  const [repExpandedKeys, setRepExpandedKeys] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const error = useRef(null)
  const currentScreen = useSelector(state => state.treeData.currentScreen)
  const trees = {
    generalTemplates: {
        data: [
            {
                title: t("LBL_BASIC_OPTIONS"),
                key: 'ntw-0',
                type: 'group',
                children: [
                    { title: t('BTN_CREATE_EMPTY_TEMPLATE'), key: 'ntw-0-0', type: 'TEMPLATE', option:t('BTN_CREATE_EMPTY_TEMPLATE') },
                    { title: t('BTN_CREATE_COPY_TEMPLATE'), key: 'ntw-0-1', type: 'TEMPLATE', option:t('BTN_CREATE_COPY_TEMPLATE')}
                ]
            },
            {
                title: 'XML Definitions',
                key: 'ntw-1',
                type: 'group',
                children: [
                    { title: t('BTN_CREATE_DTD_TEMPLATE'), key: 'ntw-1-0', type: 'TEMPLATE', option: t('BTN_CREATE_DTD_TEMPLATE') },
                    { title: t('BTN_CREATE_XSD_TEMPLATE'), key: 'ntw-1-1', type: 'TEMPLATE', option:t('BTN_CREATE_XSD_TEMPLATE') },
                    { title: t('BTN_CREATE_XMLDATA_TEMPLATE'), key: 'ntw-1-2', type: 'TEMPLATE', option:t('BTN_CREATE_XMLDATA_TEMPLATE')}
                ]
            },
           currentScreen === 'inbound' ? {
                title: 'SQL Definitions',
                type: 'group',
                key: 'ntw-2',
                children: [
                    { title: t('BTN_CREATE_SQL_TEMPLATE'), key: 'ntw-2-0', type: 'TEMPLATE', option:t('BTN_CREATE_SQL_TEMPLATE')}
                ]
            }: null,
            {
                title: 'Delimited Header',
                type: 'group',
                key: 'ntw-3',
                children: [
                    { title: t('BTN_CREATE_CSV_TEMPLATE'), key: 'ntw-3-0', type: 'TEMPLATE', option:t('BTN_CREATE_CSV_TEMPLATE')}
                ]
            },
            {
                title:t('LBL_EDI_TYPE'),
                type:'group',
                key:'ntw-4',
                children:[
                    { title: t('BTN_CREATE_SEF_TEMPLATE'), key: 'ntw-4-0', type: 'TEMPLATE', option:t('BTN_CREATE_SEF_TEMPLATE')}
                ]
            },
            {   title:t('JSON'),
                type:'group',
                key:'ntw-5',
                children: [
                    { title: t('BTN_CREATE_EMPTY_JSON_TEMPLATE'), key: 'json-5-0', type: 'TEMPLATE', option:t('BTN_CREATE_EMPTY_JSON_TEMPLATE')},
                    { title: t('BTN_CREATE_FROM_DATA'), key: 'json-5-1', type: 'TEMPLATE',option:t('BTN_CREATE_FROM_DATA')},
                    { title: t('BTN_CREATE_FROM_SCHEMA'), key: 'json-5-2', type: 'TEMPLATE',option:t('BTN_CREATE_FROM_SCHEMA')},
                ]
            }
            
        ].filter(Boolean)
    },
  } 
  const generalTemplatesTree = trees.generalTemplates.data;
  
  useEffect(()=>{
    dispatch(api.endpoints.getRepositoryTemplates.initiate({
      account:account,
      template_type: currentScreen === "inbound" ? "INBOUND" : "OUTBOUND"
    })).then(response =>{
        if(response.error){
          setIsLoading(false)
          setRepositoryTemplateTree([])
          if (error.current) {
            error.current.textContent = t("BOX_MSG_GENERAL_ERROR");
          }
        }
        if(response?.data?.current_state === 'SUCCESS'){
        setRepositoryTemplateTree(convertData(response.data.data))
        setIsLoading(false)
      }
      else{
        setRepositoryTemplateTree([])
        setIsLoading(false)
        if (error.current) {
          error.current.textContent = t("BOX_MSG_GENERAL_ERROR");
        }
      }
    })
  },[])

  function convertData(data, parentKey = '') {
    return data.map((item, index) => {
      const key = parentKey ? `${parentKey}-${index}` : `rep-${index}`;
  
      const children = item.children && item.children.length > 0
        ? item.children.map((child, childIndex) => {
          return {
            title: child.title,
            key: `${key}-${childIndex}`,
            type: 'group',
            option: child.title =='inbound_templates' ? child.path : child.title,
            path: child.path,
            children: child.children ? convertData(child.children, `${key}-${childIndex}`) : []
          };
        })
        : [];
  
      return {
        title: item.title,
        key: key,
        type: 'group',
        path: item.path,
        children: children,
        option: item.title =='inbound_templates' ? item.path : item.title
      };
    });
  }
  
  const onExpand = (expandedKeys, e, tree) => {
    //console.log("onExpand", expandedKeys);
    if (tree === "gen") setGenExpandedKeys(expandedKeys);
    else setRepExpandedKeys(expandedKeys);
  };

  const onSelect = (selectedKeys, instance, tree) => {
    let node = instance.node;

    if (node.children && node.children.length) {
      //if node is a parent - toggle node's expanded bool.
      if (!node.expanded) {
        if (tree === "gen") setGenExpandedKeys([...genExpandedKeys, node.key]);
        else setRepExpandedKeys([...repExpandedKeys, node.key]);
      } else {
        if (tree === "gen") setGenExpandedKeys(genExpandedKeys.filter(e => e !== node.key));
        else setRepExpandedKeys(repExpandedKeys.filter(e => e !== node.key));
      }
    } else {
      //if node is a child - deselect all of other tree and select node on clicked tree.
      if (tree === "gen") {
        setRepSelectedKeys([]);
        setGenSelectedKeys(selectedKeys);
      } else {
        setGenSelectedKeys([]);
        setRepSelectedKeys(selectedKeys);
        dispatch(newTemplateActions.setRepTemplateDetails(node))
      }
      //update slice so the content panel renders new options.
      const option = node?.path || node.title
      dispatch(newTemplateActions.setNewTemplateOption(option || false))
      dispatch(newTemplateActions.setNewTemplateOptionTitle(node.title || false))
      //Ensure that the selected Repository template is removed from the redux upon a change in the tree's selection.
      // Also, verify that a selection has been made from the list or table before proceeding with the "Finish" action.
      //  dispatch(newTemplateActions.setSelectedRepTemplate(''))  
      //  dispatch(newTemplateActions.setIsFormData(false)) 
      dispatch(newTemplateActions.resetFields())
      }
  };

  const Icon = (node) => {
    return node.type ==='TEMPLATE' ? <span className="GET_DATA"></span> : <span className="RECORD"></span>

  }

  const switcherIcon = (obj) => {
    if (obj.isLeaf) return;
    if (obj.expanded) return <ArrowDropDownIcon />
    else return <ArrowRightIcon sx={{color: '#666666'}}/>
  }

  return (
    <div  className="ntw-main-container">
      <div className="search-container" >
        <div className="search">
          <InputBase
            variant="outlined"
            className="search-input"
            placeholder="Search"
          />
          <IconButton type="button" sx={{ p: "5px" }}>
            <SearchIcon />
          </IconButton>
        </div>
      </div>
      <div className="ntw-tree-outer">
        <div className="ntw-tree-inner">
          {/* General Templates */}
          <div className="ntw-items" style={{overflowY:'hidden'}}>
            <div className="ntw-items-head">
              <p> GENERAL TEMPLATES</p>
            </div>
            <div>
              <Tree
                focusable={true}
                showLine
                autoFocus
                onExpand={(e, i) => onExpand(e, i, "gen")}
                onSelect={(e, i) => onSelect(e, i, "gen")}
                treeData={generalTemplatesTree}
                onActiveChange={(key) => console.log("Active :", key)}
                icon={Icon}
                selectedKeys={genSelectedKeys}
                expandedKeys={genExpandedKeys}
                showIcon
                switcherIcon={switcherIcon}
                disabled={disableTree}
              />
            </div>
          </div>
          <Divider />

          {/* Repository */}
          {isLoading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100px",
              }}>
              <CircularProgress />
            </Box>
          ) : (
            <div className="ntw-items" style={{overflowY:'hidden'}}>
              <div className="ntw-items-head">
                <p style={{textTransform:'uppercase'}}>{t('MNU_REPOSITORY')}</p>
              </div>
              <div>
                {repositoryTemplateTree?.length > 0 ? <Tree
                  focusable={true}
                  showLine
                  autoFocus
                  onExpand={onExpand}
                  onSelect={onSelect}
                  treeData={repositoryTemplateTree}
                  onActiveChange={(key) => console.log("Active :", key)}
                  icon={Icon}
                  selectedKeys={repSelectedKeys}
                  expandedKeys={repExpandedKeys}
                  showIcon
                  switcherIcon={switcherIcon}
                  disabled={disableTree}
                /> : 
                <div>
                <p className="error" ref={error}>{t('BOX_MSG_GENERAL_ERROR')}</p>
              </div>}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
